/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b23362d661b1d96937e16111df60b38e>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Glasses".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/glasses
 * Usage guidance:
 * Known uses: Changing tone of written content to Educational with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const GlassesIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "GlassesIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.81 2.433-1.804.82c-.353.16-.599.491-.65.876l-.433 3.245A3.5 3.5 0 0 1 3.5 7c1.184 0 2.23.587 2.863 1.486A3 3 0 0 1 8 8c.604 0 1.167.179 1.637.486A3.5 3.5 0 0 1 12.5 7c.567 0 1.103.135 1.577.374l-.433-3.245a1.13 1.13 0 0 0-.65-.876l-1.804-.82.62-1.366 1.805.82A2.63 2.63 0 0 1 15.13 3.93l.76 5.697A3.505 3.505 0 0 1 12.5 14a3.5 3.5 0 0 1-3.453-4.074A1.5 1.5 0 0 0 8 9.5c-.407 0-.776.162-1.047.426q.046.281.047.574a3.5 3.5 0 1 1-6.89-.873L.87 3.93a2.63 2.63 0 0 1 1.515-2.042l1.805-.82zM1.5 10.546a2 2 0 1 0 .083-.617zm12.917-.617.082.617a2 2 0 1 1-.082-.617" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
GlassesIcon.displayName = 'GlassesIcon';
var _default = exports.default = GlassesIcon;